<div class="du-mail-popup">
  <div class="d-flex align-items-center justify-content-between du-mail-popup-header-bg">
    <div class="du-mail-popup-header">
      <mat-icon class="back-icon"
        (click)="data === 'USER_ACCESS_REQUEST' ? resetBrandSelection() : ''">arrow_back</mat-icon> Mail
      Templates
    </div>
    <mat-icon class="du-mail-popUp-close" (click)="popUpClose()">close</mat-icon>
  </div>

  <div class="du-mail-popup-container">
    <!-- Show loading indicator while templates are being loaded -->
    <app-progress-indefinite class="progress-indicator"
      *ngIf="isLoading && !fromEmailExtracts"></app-progress-indefinite>

    <ng-container *ngIf="fromEmailExtracts">
      <div style="padding: 20px 15px 0;">
        <mat-form-field style="width: 100%" appearance="fill" class="matFformFieldConfig">
          <mat-label>Choose Brand</mat-label>
          <mat-select [(ngModel)]="selectedBrandKey">
            <mat-option style="font-family: 'Poppins';" *ngFor="let brand of Brands" [value]="brand.brand_key"
              title="{{ brand.brand_name }}">{{ brand.brand_name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="row">
        <div class="col-12 text-center my-4">
          <button type="button" class="btn btn-primary btn-sm confirmBtnHomePopups" matTooltip="Confirm"
            matTooltipClass="expand-tooltip" [disabled]="!selectedBrandKey" (click)="selectedBrand(selectedBrandKey)">
            Confirm
          </button>
        </div>
      </div>
    </ng-container>

    <!-- Content to display after loading is complete -->
    <div *ngIf="!isLoading && !fromEmailExtracts">
      <!-- Search Bar & Manage Button -->
      <div class="template-header">
        <div class="search-container" [ngClass]="{ 'w-100': data === 'USER_ACCESS_REQUEST' }">
          <mat-icon>search</mat-icon>
          <input type="search" name="search" id="search" [(ngModel)]="searchText" placeholder="Search"
            [(ngModel)]="searchText">
        </div>
        <button *ngIf="data !== 'USER_ACCESS_REQUEST'" mat-stroked-button color="primary" class="manage-button"
          (click)="toggleManageMode()">
          {{ isManageMode ? 'Close Manage Mode' : 'Manage Templates' }}
        </button>
      </div>

      <!-- Template List -->
      <div class="template-list">
        <div class="template-item" *ngFor="let template of templates | searchText:searchText; let i = index">
          <div class="template-info d-flex align-items-center justify-content-between">
            <div class="template-title-container d-flex align-items-center">
              <span class="template-title">{{ template.template_name }}</span>
              <mat-icon style="margin-left: 8px; width: 10px;" svgIcon="attachment_clip"></mat-icon>
            </div>
            <div class="template-actions d-flex align-items-center">
              <mat-icon *ngIf="isManageMode" svgIcon="edit_template" (click)="openEditComponent(template)"
                style="width: 15px; margin-right: 8px;"></mat-icon>
              <mat-icon *ngIf="isManageMode" svgIcon="delete_template" (click)="openDeleteComponent(template, i)"
                style="width: 15px; margin-right: 8px;"></mat-icon>
              <mat-icon *ngIf="!isManageMode" class="arrow-icon"
                (click)="selectTemplate(template)">arrow_forward_ios</mat-icon>
            </div>
          </div>
          <hr class="template-divider">
          <div class="template-desc-container">
            <span class="template-desc">{{ template.template_desc }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- No templates Available Message - shown after confirm is clicked when no templates exist -->
    <ng-container *ngIf="showNoBrandsMessage">
      <div class="no-brands-message">
        <div class="text-center">
          <mat-icon class="no-brands-icon">warning</mat-icon>
          <h4 class="mt-3">No Templates Available</h4>
          <p class="text-muted">
            Please select a different brand to view templates.
          </p>
          <button type="button" class="scraii-primary-btn mt-3" (click)="resetBrandSelection()">
            OK
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</div>